import { render } from "./OpenPopupButton.vue?vue&type=template&id=1a64470e&ts=true"
import script from "./OpenPopupButton.vue?vue&type=script&lang=ts"
export * from "./OpenPopupButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__